import { StyleSheet } from '@patternfly/react-styles';
import './bullseye.css';
export default StyleSheet.parse(".pf-l-bullseye{--pf-l-bullseye--Padding:0;display:flex;align-items:center;justify-content:center;height:100%;padding:var(--pf-l-bullseye--Padding);margin:0;}");